import { TOKEN_SESSION_STORAGE_KEY } from "./constants";
import { USER_DATA_SESSION_STORAGE_KEY } from "./constants";
import { client } from "./index";

export interface IUserData {
  firstNames: string;
  fullName: string;
  clientNumber: string;
}

const EXPIRES_IN = 1000 * 60 * 60 * 6; // 6h

function getToken() {
  const stored = sessionStorage.getItem(TOKEN_SESSION_STORAGE_KEY);

  if (stored == null) {
    return null;
  }

  const token_json = JSON.parse(stored);
  const now = Date.now();

  if (token_json.expires < now) {
    clearSessionStorage();
    return null;
  }

  return token_json.token;
}

function setToken(token: string) {
  const now = Date.now();
  const expires = now + EXPIRES_IN;
  const token_json = JSON.stringify({ token: token, expires: expires });
  sessionStorage.setItem(TOKEN_SESSION_STORAGE_KEY, token_json);
}

function clearSessionStorage() {
  sessionStorage.removeItem(TOKEN_SESSION_STORAGE_KEY);
  sessionStorage.removeItem(USER_DATA_SESSION_STORAGE_KEY);

  // Clear out the GraphQL cache
  client.resetStore();
}

function getUserData() {
  return sessionStorage.getItem(USER_DATA_SESSION_STORAGE_KEY);
}

function setUserData(data: object) {
  sessionStorage.setItem(USER_DATA_SESSION_STORAGE_KEY, JSON.stringify(data));
}

export { getToken, setToken, clearSessionStorage, getUserData, setUserData };
